export default __webpack_public_path__ + "static/media/logo.7f6d3ccc.svg";